"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeObserverPolyfill = void 0;
exports.ResizeObserverPolyfill = require("resize-observer-polyfill").default;
exports.default = exports.ResizeObserverPolyfill;
//# sourceMappingURL=ResizeObserver.js.map